<template>
    <div>
        <!-- dialog -->
        <v-dialog
            v-model="mergeDialog"
            transition="dialog-transition"
            persistent
            max-width="350"
            @keydown.esc="mergeDialog = false"
        >
            <v-card>
                <div class="d-flex justify-end py-1 background-title-card ">
                    <v-card-title class="text-uppercase text-subtitle-1 flex-grow-1 justify-center pa-0 white--text">
                        {{ !managementHierarchyRegions ? $t('RegionManagement.merge-regions') :  $t('RegionManagement.merge-areas')}}    
                    </v-card-title>

                    <!-- close button -->
                    <v-btn icon @click="mergeDialog = false">
                        <v-icon color="white">
                            mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </div>
                <v-card-text class="pt-2 px-3 pb-0">
                    <v-row dense class="ma-0">
                        <p>
                            {{ 
                                !managementHierarchyRegions ? 
                                    $t('RegionManagement.do-you-want-to-merge-the-region-with-another-region') + $t('?') : 
                                $t('RegionManagement.do-you-want-to-merge-the-area-with-another-area') + $t('?')
                            }}
                        </p>
                        <v-col align-self="center" class="pa-1">
                            <v-autocomplete
                                v-model="newRegion" 
                                :items="regions"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                hide-details
                                :label="managementHierarchyRegions ? $t('inputs.areas') : $t('inputs.region') "
                            />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn
                        type="submit"
                        :loading="submitLoading"
                        color="success white--text"
                        text
                        @click="merge()"
                    >
                        {{$t('save')}}
                    </v-btn>
                    <v-btn
                        @click="
                            $refs.deleteDialog.activeDeleteDialog(itemId, 'regions'); 
                            $refs.deleteDialog.setAdditionalData({ cityId: cityItemId })
                        "
                        text
                        >
                        <!--  -->
                        {{$t('cancel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="d-flex align-center">
            <!-- Add new one -->
            <v-btn
                v-if="isSuperAdmin || permissionsUser.Regions === roleName.action"
            	small
            	color="light-blue white--text"
            	@click="resetInputs(); dialog = true;"
                :disabled="!isSuperAdmin && tab === 0 || !isSuperAdmin && tab === 2"
            >
                <v-icon class="me-2">
                    mdi-plus-circle-outline
                </v-icon>
                {{ $t('add') }} {{currentTabLabel}}
            </v-btn>
        </div>
        <!-- region dialog -->
        <v-dialog
            v-model="dialog"
            transition="dialog-transition"
            persistent
            max-width="350"
            @keydown.esc="dialog = false"
        >
            <v-form @submit.prevent="submit" ref="form" :disabled="submitLoading">
                <v-card>
                    <div class="d-flex justify-end py-1 background-title-card ">
                        <v-card-title class="text-uppercase text-subtitle-1 flex-grow-1 justify-center pa-0 white--text">
                            {{ title = (!editItemId ? $t('add') : $t('update')) + ' ' + currentTabLabel }}
                        </v-card-title>

                        <!-- close button -->
                        <v-btn icon @click="dialog = false; $refs.form.resetValidation()">
                            <v-icon color="white">
                                mdi-close-circle-outline
                            </v-icon>
                        </v-btn>
                    </div>
                    <v-card-text class="pt-2 px-3 pb-0">
                        <v-row dense class="ma-0">
                            <!-- Name -->
                            <v-col cols="12">
                                <v-text-field
                                    v-model="dialogData.name"
                                    :label="$t('inputs.name')"
                                    clearable
                                    :rules="rules.required"
                                    required
                                    outlined
                                    dense
                                    hide-details="auto"
                                    autofocus
                                ></v-text-field>
                            </v-col>

                            <v-col v-if="managementHierarchyRegions && tab === managementType.city" cols="12">
                                <v-autocomplete 
                                    v-model="dialogData.provinceId"
                                    :label="$t('inputs.province')"
                                    clearable
                                    :items="provinces"
                                    item-text="name"
                                    item-value="id"
                                    outlined
                                    dense
                                    hide-details="auto"
                                />
                            </v-col>

                            <!-- City -->
                            <v-col v-if="tab !== managementType.city && tab !== managementType.province" cols="12">
                                <v-autocomplete
                                    v-model="dialogData.cityId"
                                    :label="$t('inputs.city')"
                                    clearable
                                    :items="cities"
                                    item-text="name"
                                    item-value="id"
                                    :rules="rules.required"
                                    required
                                    outlined
                                    dense
                                    hide-details="auto"
                                    :multiple="tab === managementType.sector"
                                    @change="tab === managementType.sector ? fetchRegionsDueDialogCities() : null"
                                ></v-autocomplete>
                            </v-col>

                            <v-col v-if="tab === managementType.region && extraField" cols="12">
                                <v-btn-toggle
                                    v-model="dialogData.isRural"
                                    mandatory
                                    dense
                                    class="mb-1"
                                    color="primary"
                                >
                                    <v-btn>{{$t('inputs.city')}}</v-btn>
                                    <v-btn> {{$t('inputs.rural')}} </v-btn>
                                </v-btn-toggle>
                            </v-col>
                            
                            <!-- Regions in sector -->
                            <v-col v-if="tab === managementType.sector" cols="12">
                                <v-autocomplete
                                    v-model="dialogData.regionIds"
                                    :label="managementHierarchyRegions 
                                        ? ('RegionManagement.areas-in-regions') 
                                        : $t('RegionManagement.regions-in-area')
                                    "
                                    clearable
                                    :loading="regionsDialogLoading"
                                    :disabled="
                                        (Array.isArray(dialogData.cityId) && !dialogData.cityId.length) || regionsDialogLoading
                                    "
                                    :items="regionsDueCities"
                                    item-text="name"
                                    item-value="id"
                                    multiple
                                    :rules="rules.required"
                                    required
                                    outlined
                                    dense
                                    hide-details="auto"
                                >
                                    <template v-slot:prepend-item v-if="regionsDueCities.length">
                                        <v-list-item ripple @click="toggle">
                                            <v-list-item-action>
                                                <v-icon>
                                                    {{ icon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{$t('select-all')}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>

                                    <template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0" class="me-1">
                                            {{ item.name }}
                                        </span>
                                        <span v-if="index === 1" class="grey--text text-caption">
                                            (+{{ dialogData.regionIds.length - 1 }})
                                        </span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                        <v-btn
                            type="submit"
                            :loading="submitLoading"
                            color="success white--text"
                            text
                        >
                            {{$t('save')}}
                        </v-btn>
                        <v-btn
                            @click="dialog = false"
                            text
                            :disabled="submitLoading"
                        >
                            {{$t('cancel')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- delete dialog declared here to use it as ref -->
        <delete-dialog
            ref="deleteDialog"
            @on-delete="updateData"
            :success-message="$t('message.data-is-deleted')"
        >
            {{ $t('are-you-sure-you-want-to') }} <span class="red--text">{{ $t('delete') }}</span> {{$t('this')}} {{ currentTabLabel}}?
        </delete-dialog>

        <!-- tabs -->
        <v-tabs v-model="tab">
            <v-tab v-for="title in tabs.titles" :key="title" class="text-capitalize">
                {{ title }}
            </v-tab>
            <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>
        <v-divider class="mb-2"/>
        
        <!-- city filter -->
        <v-row  no-gutters class="ma-0 mb-2">
            <v-col v-if="tab === managementType.region" sm="auto" cols="12">
                <v-autocomplete
                    v-model="cityId"
                    :label="$t('inputs.city')"
                    :items="cities"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    clearable
                    :loading="regionsLoading"
                    @change="fetchRegionsDueCity"
                ></v-autocomplete>
            </v-col>

            <v-col v-if="tab === managementType.city && managementHierarchyRegions" sm="auto" cols="12">
                <v-autocomplete
                    v-model="provinceId"
                    :label="$t('inputs.province')"
                    :items="provinces"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    clearable
                    :loading="regionsLoading"
                    @change="fetchCitiesDueProvince"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <!-- table -->
        <bee-handy-table
            :headers="headers"
            :items="!loading && !regionsLoading ? managementHierarchyRegions ? [provinces ,cities, regions, sectorsMine][tab] : [cities, regions, sectorsMine][tab] : []"
            pagination-on-scroll
            :items-per-page="20"
            :data-table-props="
                tab === managementType.region
                ? { noDataText: cityId == null 
                    ? $t('RegionManagement.please-select-a-city') 
                    : !managementHierarchyRegions ? $t('RegionManagement.no-regions-in-this-city') : $t('RegionManagement.No areas in this city')
                }
                : undefined
            "
            dense
            zebra
            :loading="loading || regionsLoading"
            fixed-header
            :height="$vuetify.breakpoint.height - (tab === managementType.region ? 188 : 146)"
            :shown-rows-text="$t('shown-rows')"
        >
            <template v-slot:item.action="{ item }">
                <div class="d-flex justify-center">
                    <!-- city -->
                    <tooltip 
                        v-if="tab === managementType.city || tab === managementType.province" 
                        :text="tab === managementType.city ? !managementHierarchyRegions ? $t('RegionManagement.show-regions') : $t('RegionManagement.show-areas') : $t('RegionManagement.show-cities') " 
                        top
                    >
                        <v-btn
                        	icon
                        	color="success"
                        	small
                        	@click="
                                showRegionOrCity(item)
                            "
                        >
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </tooltip>

                    <!-- edit -->
                    <tooltip :text="$t('edit') + ' ' + currentTabLabel" top>
                        <v-btn
                        	icon
                        	@click="editItem(item.id)"
                        	color="edit-color"
                        	small
                            class="mx-2"
                        >   
                            
                            <v-icon>
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </tooltip>
                    <!-- delete -->
                    <tooltip :text="$t('delete') + ' ' + currentTabLabel" top>
                        <v-btn
                            icon
                            small
                            @click="deleteForTabs(item)"
                            color="alert-color"
                        >
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </tooltip>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Tooltip from '@/components/Tooltip'
import DeleteDialog from '@/components/DeleteDialog';
import rules from '@/validation rules';
import { roleName } from '@/helpers/enums';
import { extraField, managementHierarchyRegions } from '@/configs/global.config'

export default {
    name: 'Regions',

    components: {
        Tooltip,
        DeleteDialog
    },

    data: () => ({
        newRegion: null,
        cityItemId: null, 
        itemId: null,
        // helpers
        tab: 0,
        roleName,

        loading: false,
        regionsLoading: false,

        // filter
        cityId: null,

        // region dialog data
        editItemId: null,
        managementType: managementHierarchyRegions 
        ? {
            province: 0,
            city: 1,
            region: 2,
            sector: 3,
        } 
        : { 
            city: 0,
            region: 1,
            sector: 2,
        },

        regionsDialogLoading: false,
        regionsDueCities: [],
        
        submitLoading: false,
        dialog: null,

        rules,
        
        dialogData: {
            name: null,
            regionIds: [],
            cityId: [],
            provinceId: null,
            isRural: 0
        },
        mergeDialog: false,
        provinceId: null,
        // config
        extraField,
        managementHierarchyRegions
    }),

    watch: {
        tab(newVal) {
            if (newVal === this.managementType.region) {
                this.cityId = null;
                this.$store.dispatch('regions/clearRegions');
            }
        },
        mergeDialog(val) {
            if (!val) {
                this.newRegion = null
                this.itemId = null
                this.cityItemId = null
            }
        }
    },

    computed: {
        ...mapState({
            sectors: state => state.sectors.sectors,
            regions: state => state.regions.regions,
            cities: state => state.cities.cities,
            permissionsUser: state => state.auth.youPermissions,
            isSuperAdmin: state => state.auth.isSuperAdmin,
            sectorCities: state => state.sectors.sectorCities.sectors,
            provinces: state => state.provinces.provinces,
            sectorsMine: state => state.sectors.sectorsMine
        }),

        ...mapGetters({
            getCityById: 'cities/getCityById',
            getCityByName: 'cities/getCityByName',
            getRegionById: 'regions/getRegionById',
            getSectorById: 'sectors/getSectorById',
            getCityNameBySectorId: 'sectors/getCityNameBySectorId',
            getSectorCitiesById: 'sectors/getSectorCitiesById',
            getProvinceById: 'provinces/getProvinceById'
        }),

        currentTabLabel() {
            return this.tabs.labels[this.tab];
        },

        // tabs() {
      
        // },

        // region dialog
        icon () {
            // const selectedAllSectors = this.dialogData.regionIds.length === this.regionsDueCities.length
            // if (selectedAllSectors) return 'mdi-close-box';
            // if (this.dialogData.regionIds.length > 0 && !selectedAllSectors) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline';
        },

        headers() {
            const headers = [
                { 
                    text: this.$t('headers.name'), 
                    value: 'name',
                    class: 'text-body-2 font-weight-bold',
                }
            ]
            if (this.isSuperAdmin || this.permissionsUser.Regions === roleName.action) {
                headers.push(
                    {
                        text: '',
                        name: 'action',
                        value: 'action',
                        align: 'center',
                        class: 'text-body-2 font-weight-bold',
                        sortable: false,
                    }
                )
            }

            return headers
        },

        tabs () {
            return {
                titles: managementHierarchyRegions 
                    ? [
                        this.$t('RegionManagement.provinces'), 
                        this.$t('RegionManagement.cities'), 
                        this.$t('RegionManagement.areas'), 
                        this.$t('RegionManagement.regions')
                    ] 
                    : [
                        this.$t('RegionManagement.cities'), 
                        this.$t('RegionManagement.regions'), 
                        this.$t('RegionManagement.areas')
                    ],
                labels: managementHierarchyRegions 
                    ? [
                        this.$t('RegionManagement.province'), 
                        this.$t('RegionManagement.city'), 
                        this.$t('RegionManagement.area'), 
                        this.$t('RegionManagement.region')
                    ] 
                    : [
                        this.$t('RegionManagement.city'), 
                        this.$t('RegionManagement.region'), 
                        this.$t('RegionManagement.area')
                    ]
            }
        },
    },

    methods: {
        fetchRegionsDueCity() {
            if (this.cityId) {
                this.regionsLoading = true;
                return this.$store.dispatch('regions/fetchAll', { cityId: this.cityId }).finally(() => {
                    this.regionsLoading = false;
                });
            }
        },
        fetchCitiesDueProvince () {
            if (this.provinceId) {
                this.regionsLoading = true;
                return this.$store.dispatch('cities/fetchCityMine', { provinceId: this.provinceId }).finally(() => {
                    this.regionsLoading = false;
                });
            } else {
                return this.$store.dispatch('cities/fetchCityMine', {})
            }
        },

        updateData() {
            let promise;
            if (!managementHierarchyRegions) {
                switch (this.tab) {
                    case 0: promise = this.$store.dispatch('cities/fetchCityMine', {}, {}); break;
                    case 1: promise = this.fetchRegionsDueCity(); break;
                    case 2: promise = this.$store.dispatch('sectors/getSectorsMine'); break;
                    default: return;
                }
                promise.finally(() => { this.loading = false; this.mergeDialog = false })
            } else {
                switch (this.tab) {
                    case 0: promise = this.$store.dispatch('provinces/fetchAll'); break;
                    case 1: promise = this.$store.dispatch('cities/fetchCityMine', {}, {}); break;
                    case 2: promise = this.fetchRegionsDueCity(); break;
                    case 3: promise = Promise.all([
                        this.$store.dispatch('cities/fetchCityMine', {}, {}).then((data) => {
                            this.$store.dispatch('sectors/fetchSectorCities', { cities: data })
                        })
                    ]); break;
                    default: return;
                }
                promise.finally(() => { this.loading = false; this.mergeDialog = false })
            }
            this.loading = true;
        },

        // region dialog
        fetchRegionsDueDialogCities() {
            if (Array.isArray(this.dialogData.cityId) && this.dialogData.cityId.length){
                this.regionsDialogLoading = true;
                this.regionsDueCities = [];
                this.dialogData.cityId.forEach(cityId => {
                    this.$store.dispatch('regions/fetchAll', { cityId }).then((regions) => {
                        this.regionsDueCities.push(...regions);
                    })
                    .finally(() => {
                        this.regionsDialogLoading = false;
                    });
                });
            }
        },

        resetInputs(){
            if (this.$refs.form) this.$refs.form.resetValidation();

            this.editItemId = null;
            this.regionsDueCities = [];
            
            this.dialogData.name = null;
            this.dialogData.provinceId = null;
            this.dialogData.isRural = 0;
            this.dialogData.cityId = this.tab === this.managementType.region ? this.cityId : [];
            this.dialogData.regionIds = [];
        },

        editItem(id){
            this.editItemId = id;
            if (managementHierarchyRegions && this.tab === this.managementType.province) {
                this.dialogData.name = this.getProvinceById(id).name
            }
            if (this.tab === this.managementType.city){
                this.dialogData.name = this.getCityById(id).name;
                this.dialogData.provinceId = this.managementHierarchyRegions ? this.getCityById(id).provinceId : null      
            }
            else if (this.tab === this.managementType.region){
                this.dialogData.name = this.getRegionById(id).name;
                this.dialogData.cityId = this.getCityById(this.cityId).id;
                this.dialogData.isRural = this.getRegionById(id).isRural ? 1 : 0
            }
            else if (this.tab === this.managementType.sector){
                var cityNames = []
                this.dialogData.name = this.getSectorCitiesById(id)?.name;
                this.loading = true
                this.$store.dispatch('sectors/fetchCitiesInSector', { id: id }).then((data) => {
                    this.dialogData.cityId = data.map(c => c.id);
                    this.fetchRegionsDueDialogCities();
                }).finally(() => {
                    this.loading = false
                })
                
                this.dialogData.regionIds = this.getSectorCitiesById(id)?.regionIds;
            }
            this.dialog = true;
        },

        submit(){
            if (this.$refs.form.validate()){
                let moduleType, msgType;
                switch (this.tab) {
                    case this.managementType.province: moduleType = 'provinces'; msgType = 'Province'; break;
                    case this.managementType.city: moduleType = 'cities'; msgType = 'City'; break;
                    case this.managementType.region: moduleType = 'regions'; msgType = 'Region'; break;
                    case this.managementType.sector: moduleType = 'sectors'; msgType = 'Sector'; break;
                }

                this.submitLoading = true;
                const actionName = !this.editItemId ? 'create' : 'update';
                this.$store.dispatch(`${moduleType}/${actionName}`, {
                    id: this.editItemId,
                    name: this.dialogData.name,
                    isRural: this.dialogData.isRural ? Boolean(this.dialogData.isRural) : null,
                    cityId: this.dialogData.cityId, // for regions
                    regionIds: this.dialogData.regionIds, // for sectors
                    provinceId: this.dialogData.provinceId
                })
                .then(() => {
                    const message =
                        this.currentTabLabel.charAt(0).toLocaleUpperCase() +
                        this.currentTabLabel.slice(1) +
                        ' is ' + (actionName === 'create' ? this.$t('created') : this.$t('edited'));
                    this.$eventBus.$emit('show-snackbar', message, 'info');
                    this.dialog = false
                    this.resetInputs();
                    // if (this.cityId !== null) {
                    this.updateData()
                    // } 
                    if (moduleType === 'regions') {
                        // this.$store.dispatch('regions/fetchAllRegions', {})
                        this.$store.dispatch('regions/fetchAllRegions', {
                            cities: this.cities
                        })
                    }
                    if (moduleType === 'cities') {
                        this.$store.dispatch('cities/fetchCityMine', {})
                    }
                })
                .finally(() => {
                    this.submitLoading = false;
                })
            }
        },

        toggle () {
            this.$nextTick(() => {
                if (this.dialogData.regionIds.length === this.regionsDueCities.length) this.dialogData.regionIds = [];
                else this.dialogData.regionIds = this.regionsDueCities.map(c => c.id);
            })
        },
        merge() {
            this.submitLoading = true
            this.$store.dispatch('regions/merge', { oldRegionId: this.itemId, newRegionId: this.newRegion }).then(() => {
                this.$store.dispatch('regions/delete', { id: this.itemId }).then(() => {
                    this.updateData()
                })
            }).finally(() => {
                this.submitLoading = false
                this.mergeDialog = false
            })
        },

        showRegionOrCity(item) {
            if (this.tab === this.managementType.city) {
                this.tab = this.managementType.region;
                this.$nextTick(() => { this.cityId = item.id; this.fetchRegionsDueCity() })
            } else {
                this.tab = this.managementType.city;
                this.$nextTick(() => { this.provinceId = item.id; this.fetchCitiesDueProvince() })
            }                     
        },

        deleteForTabs(item) {
            if (this.tab === this.managementType.region) {
                this.itemId = item.id;
                this.cityItemId = item.cityId;
                this.mergeDialog = true
            } else if (this.tab === this.managementType.sector) {
                this.$refs.deleteDialog.activeDeleteDialog(item.id, 'sectors')
            } else if (this.tab === this.managementType.province) {
                this.$refs.deleteDialog.activeDeleteDialog(item.id, 'provinces')
            } else {
                this.$refs.deleteDialog.activeDeleteDialog(item.id, 'cities')
            }
        }
    },

    mounted(){
        this.loading = true;
        Promise.all([
            !this.cities.length ? this.$store.dispatch('cities/fetchCityMine', {}, {}).then((data) => {
                // this.$store.dispatch('sectors/fetchSectorCities', { cities: data.map(c => c.id) })
            }) : null,
            // !this.sectorsMine.length ? 
            this.$store.dispatch('sectors/getSectorsMine') 
            // : null
        ]).finally(() => {
            this.loading = false;
        })
        this.$store.dispatch('regions/clearRegions');
        if (this.managementHierarchyRegions) {
            this.$store.dispatch('provinces/fetchAll')
        } 
    },

    metaInfo: {
        title: !managementHierarchyRegions ? 'Regions Management' : 'Areas Management',
        titleTemplate: '%s | Octopharma'
    }
}
</script>